import { makePaymentModalTitleElem } from './constants'

export default function paymentModalTitle (messageAccount = null) {
  const message = ['Make Payment', messageAccount].filter(function (word) {
    return typeof word === 'string'
  }).join(': ')

  makePaymentModalTitleElem.text(message)
}
